module.exports = __webpack_public_path__ + "img/main.786adb3f.png";